import nlp from "compromise";
import { createAnchor, getPositionFromIndex } from "./AutoSuggestion";
export function numberToWords(num) {
    if (num === 0) return "zero";

    const ones = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
    const teens = ["ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
    const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
    const scales = ["", "thousand", "million", "billion", "trillion"];

    function convertGroup(n) {
        let str = "";
        if (n >= 100) {
            str += ones[Math.floor(n / 100)] + " hundred ";
            n %= 100;
        }
        if (n >= 10 && n <= 19) {
            str += teens[n - 10];
        } else if (n >= 20) {
            str += tens[Math.floor(n / 10)] + (n % 10 !== 0 ? "-" + ones[n % 10] : "");
        } else if (n > 0) {
            str += ones[n];
        }
        return str.trim();
    }

    let wordResult = "";
    let scaleIndex = 0;

    while (num > 0) {
        let group = num % 1000;
        if (group !== 0) {
            let groupText = convertGroup(group);
            wordResult = groupText + (scales[scaleIndex] ? " " + scales[scaleIndex] : "") + (wordResult ? " " + wordResult : "");
        }
        num = Math.floor(num / 1000);
        scaleIndex++;
    }

    return wordResult.trim();
}

export function findRowColumn(textFile, index) {
    let row = 0;
    let column = 0;
    for (let i = 0; i < index; i++) {
        if (textFile[i] === "\n") {
            row++;
            column = 0;
        } else {
            column++;
        }
    }
    return {
        row: row,
        column: column
    }
}

export function getLineContent(textFile, index) {
    const lines = textFile.split("\n");
    const rowCol = findRowColumn(textFile, index);
    if (rowCol.row >= lines.length) return "";
    return lines[rowCol.row];
}

export function getLineContentBeforeindex(textFile, index) {
    const lines = textFile.split("\n");
    const rowCol = findRowColumn(textFile, index);
    if (rowCol.row >= lines.length) return "";
    return lines[rowCol.row].slice(0, rowCol.column);
}

export function LineCommented(texFile, index) {
    let lineContentBeforeIndex = getLineContentBeforeindex(texFile, index);

    for (let i = 0; i < lineContentBeforeIndex.length; i++) {
        if (lineContentBeforeIndex[i] === '%') {
            if (i === 0 || lineContentBeforeIndex[i - 1] !== '\\') {
                return true;
            }
        }
    }
    return false;
}




export const removeLines = (editor, startRow, endRow, updateTextFile) => {
    const session = editor.session;
    const Range = window.ace.require('ace/range').Range;

    try {
        const range = new Range(
            startRow,
            0,
            endRow + 1,
            0
        );

        session.remove(range);

        if (updateTextFile) {
            updateTextFile(session.getValue());
        }

        console.log(`Removed lines ${startRow + 1} to ${endRow + 1}`);
        return true;
    } catch (error) {
        console.error("Error removing lines:", error);
        return false;
    }
};


export const shouldRemoveHiddenLine = (editor, item) => {
    const session = editor.session;
    const row = item.startAnchor.row;
    const line = session.getLine(row);
    const percentIndex = line.indexOf('%');
    const hasContentBefore = percentIndex > 0 && line.slice(0, percentIndex).trim().length > 0;

    if (hasContentBefore) {
        return {
            shouldRemove: false,
            removeType: 'partial',
            startCol: percentIndex,
            endCol: line.length
        };
    }
    if (percentIndex === 0 || line.slice(0, percentIndex).trim().length === 0) {
        const prevRow = row - 1;
        const nextRow = row + 1;
        const shouldRemoveLine = true;
        return {
            shouldRemove: shouldRemoveLine,
            removeType: 'full',
            row: row
        };
    }

    return {
        shouldRemove: false,
        removeType: 'none'
    };
};


export const findTabularEnvs = (text) => {
    const results = [];
    const startRegex = /\\begin\{(tabular|longtable|array)\}(\[[^\]]*\])?\{/g;
    let startMatch;
    while ((startMatch = startRegex.exec(text)) !== null) {
        const envName = startMatch[1];
        const optArg = startMatch[2] || '';
        const colSpecStart = startMatch.index + startMatch[0].length;
        let braceCount = 1;
        let i = colSpecStart;
        while (i < text.length && braceCount > 0) {
            if (text[i] === '{') braceCount++;
            else if (text[i] === '}') braceCount--;
            i++;
        }
        if (braceCount !== 0) continue;
        const columnSpec = text.slice(colSpecStart, i - 1);
        const bodyStart = i;
        const endPattern = new RegExp(`\\\\end\\{${envName}\\*?\\}`);
        const endMatch = endPattern.exec(text.slice(bodyStart));
        if (!endMatch) continue;
        const bodyEnd = bodyStart + endMatch.index;
        const tableBody = text.slice(bodyStart, bodyEnd);
        const fullMatch = text.slice(startMatch.index, bodyEnd + endMatch[0].length);
        results.push({ start: startMatch.index, fullMatch, envName, columnSpec, tableBody });
    }
    return results;
};
// ==================== HELPER: Parse column spec ====================
export const parseColumnSpec = (spec) => {
    const parts = [];
    let i = 0;
    while (i < spec.length) {
        const ch = spec[i];
        if (ch === '|' || ch === ' ') {
            parts.push({ char: ch, isDataCol: false });
            i++;
            continue;
        }
        if (ch === '@' || ch === '!' || ch === '>' || ch === '<') {
            let block = ch;
            i++;
            if (i < spec.length && spec[i] === '{') {
                block += '{';
                let bc = 1;
                i++;
                while (i < spec.length && bc > 0) {
                    block += spec[i];
                    if (spec[i] === '{') bc++;
                    else if (spec[i] === '}') bc--;
                    i++;
                }
            }
            parts.push({ char: block, isDataCol: false });
            continue;
        }
        if (ch === 'p' || ch === 'm' || ch === 'b') {
            let block = ch;
            i++;
            if (i < spec.length && spec[i] === '{') {
                block += '{';
                let bc = 1;
                i++;
                while (i < spec.length && bc > 0) {
                    block += spec[i];
                    if (spec[i] === '{') bc++;
                    else if (spec[i] === '}') bc--;
                    i++;
                }
            }
            parts.push({ char: block, isDataCol: true, align: ch });
            continue;
        }
        if (ch === '*') {
            i++;
            if (i < spec.length && spec[i] === '{') {
                i++;
                let numStr = '';
                while (i < spec.length && spec[i] !== '}') {
                    numStr += spec[i];
                    i++;
                }
                i++;
                const repeatCount = parseInt(numStr, 10) || 1;

                if (i < spec.length && spec[i] === '{') {
                    i++;
                    let innerSpec = '';
                    let bc = 1;
                    while (i < spec.length && bc > 0) {
                        if (spec[i] === '{') bc++;
                        else if (spec[i] === '}') bc--;
                        if (bc > 0) innerSpec += spec[i];
                        i++;
                    }
                    for (let r = 0; r < repeatCount; r++) {
                        parts.push({ char: innerSpec, isDataCol: true, align: innerSpec });
                    }
                }
            }
            continue;
        }
        if (/[lcrSXRLCDQ]/.test(ch)) {
            parts.push({ char: ch, isDataCol: true, align: ch });
            i++;
            continue;
        }
        parts.push({ char: ch, isDataCol: false });
        i++;
    }
    return parts;
};


export function findCommandorNot(row, column, file) {
    let lines = file.split("\n");
    let rows = lines[row];
    for (let i = 0; i < column; i++) {
        if (rows[i] === "%" && (i === 0 || rows[i - 1] !== "\\")) {
            return true;
        }
    }
    return false;
}

// export function capitalizeInsideBraces(str, isTitleCase = true) {
//     const skipWords = [
//         "using",
//         // Articles
//         "a", "an", "the",

//         // Conjunctions
//         "and", "but", "or", "nor", "for", "so", "yet", "although", "because", "since", "unless", "whereas", "while", "although", "though",

//         // Prepositions (short + common)
//         "about", "above", "across", "after", "against", "along", "among", "around", "at", "before", "behind", "below", "beneath", "beside", "between", "beyond", "by", "despite", "down", "during", "except", "for", "from", "in", "inside", "into", "like", "near", "of", "off", "on", "onto", "out", "outside", "over", "past", "since", "through", "throughout", "till", "to", "toward", "towards", "under", "underneath", "until", "up", "upon", "with", "within", "without", "via", "per", "as", "than",

//         // Pronouns (common)
//         "i", "you", "he", "she", "it", "we", "they", "me", "him", "her", "us", "them", "my", "your", "his", "her", "its", "our", "their", "mine", "yours", "hers", "ours", "theirs", "this", "that", "these", "those", "any", "each", "few", "many", "all", "some", "most", "none", "one", "other", "another", "such", "what", "which", "who", "whom", "whose", "myself", "yourself", "himself", "herself", "itself", "ourselves", "themselves", "eachother",

//         // Adverbs / common small words
//         "even", "more", "also", "not", "just", "only", "still", "yet", "too", "very", "so", "ever", "never", "once", "always", "often", "sometimes", "usually", "rarely", "perhaps", "maybe", "actually", "indeed", "thus", "there", "here", "where", "when", "why", "how", "however", "instead", "meanwhile", "therefore", "furthermore", "additionally", "likewise", "similarly", "otherwise", "hence", "accordingly", "anyway", "anyhow", "already", "soon", "rather", "quite", "rather", "nearly", "hardly", "merely", "mostly", "mainly", "primarily", "largely", "partly", "somewhat", "relatively", "approximately", "nevertheless", "nonetheless", "besides", "aside", "henceforth", "forthwith", "altogether", "over", "under", "about", "around", "through", "throughout", "beyond", "toward", "towards", "without", "within",

//         // Common filler / linking words
//         "as", "if", "than", "until", "while", "so", "too", "like", "per", "via", "etc", "i.e", "e.g", "vs", "www", "com", "org", "net", "gov", "edu", "mil", "inc", "ltd", "co",

//         // Modifiers / small adjectives
//         "big", "small", "new", "old", "young", "other", "same", "main", "own", "first", "last", "next", "previous", "former", "latter", "only", "several", "many", "few", "some", "all", "any", "enough", "less", "more", "most", "certain", "certainly", "particular", "partly", "whole", "wholeheartedly",

//         // Common adverbs used in captions
//         "quickly", "slowly", "carefully", "easily", "hardly", "barely", "strongly", "lightly", "simply", "clearly", "visibly", "directly", "immediately", "gradually", "mainly", "primarily", "mainly", "slightly", "relatively", "partially", "usually", "commonly", "occasionally", "frequently", "rarely", "occasionally", "effectively", "accurately", "specifically", "generally", "typically", "mostly", "usually", "particularly", "especially", "sometimes", "eventually", "finally", "ultimately",

//         // Time / quantity words
//         "before", "after", "since", "until", "during", "recently", "formerly", "once", "twice", "thrice", "daily", "weekly", "monthly", "yearly", "hourly", "later", "earlier", "soon", "now", "then", "again", "already", "yet", "immediately", "eventually", "finally", "ultimately", "early", "late", "today", "yesterday", "tomorrow", "morning", "evening", "night", "afternoon", "midday", "midnight", "noon", "past", "next", "previous", "current", "following", "upcoming",

//         // Misc / others
//         "example", "examples", "fig", "figure", "table", "eq", "equation", "ref", "refs", "reference", "references", "section", "sections", "chapter", "chapters", "appendix", "appendices", "note", "notes", "supplementary", "supplement", "supplemental", "data", "dataset", "datasets", "sample", "samples", "value", "values", "parameter", "parameters", "variable", "variables", "result", "results", "observation", "observations", "method", "methods", "procedure", "procedures", "analysis", "analyses", "study", "studies", "experiment", "experiments", "test", "tests", "control", "controls", "treatment", "treatments", "group", "groups", "case", "cases", "item", "items", "part", "parts", "component", "components", "factor", "factors", "level", "levels", "type", "types", "category", "categories", "set", "sets", "range", "ranges", "line", "lines", "point", "points", "mean", "median", "mode", "variance", "standard", "deviation", "ratio", "ratios", "percentage", "percentages", "score", "scores", "scorecard", "sampled", "sampleset", "trial", "trials", "phase", "phases",

//         // Common file extensions
//         "jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "svg", "webp", "ico", "pdf", "txt", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "csv", "json", "xml", "html", "htm", "css", "js", "ts", "py", "cpp", "c", "h", "java", "rb", "php", "sh", "bat", "exe", "dll", "zip", "tar", "gz", "rar", "7z",

//         // URLs / domain names
//         "com", "org", "net", "gov", "edu", "mil", "io", "co", "info", "biz", "us", "uk", "de", "fr", "jp", "cn", "ru", "in", "au", "br", "ca", "es", "it", "nl", "se", "no", "fi", "dk", "ch", "be", "nz",

//         // Common tech / acronyms often in captions
//         "cpu", "gpu", "ram", "ssd", "hdd", "os", "ui", "ux", "api", "html", "css", "json", "xml", "sql", "db", "dns", "ip", "url", "tcp", "udp", "http", "https", "ftp", "smtp", "ssh", "tls", "ssl", "vpn", "vm", "cli", "gui", "ide", "sdk", "api", "iot", "ai", "ml", "dl", "nn", "cnn", "rnn", "lstm", "gan", "url", "uri", "jpg", "png", "gif", "bmp"
//     ];


//     let result = "";
//     let i = 0;
//     let isFirstWord = true; // Track if this is the first word in the string
//     let afterPeriod = false; // Track if we're after a period

//     while (i < str.length) {
//         // ==================== Handle Math $...$ ====================
//         if (str[i] === '$' && (i === 0 || str[i - 1] !== '\\')) {
//             result += '$';
//             i++;
//             while (i < str.length) {
//                 if (str[i] === '$' && str[i - 1] !== '\\') {
//                     result += '$';
//                     i++;
//                     break;
//                 }
//                 result += str[i];
//                 i++;
//             }
//             continue;
//         }

//         // ==================== Handle LaTeX Commands \\command{} ====================
//         if (str[i] === '\\' && i + 1 < str.length && /[a-zA-Z]/.test(str[i + 1])) {
//             result += '\\';
//             i++;

//             // Read command name (preserve case)
//             while (i < str.length && /[a-zA-Z]/.test(str[i])) {
//                 result += str[i];
//                 i++;
//             }

//             // Skip whitespace after command
//             while (i < str.length && /\s/.test(str[i])) {
//                 result += str[i];
//                 i++;
//             }

//             // Handle braces after command
//             if (i < str.length && str[i] === '{') {
//                 result += '{';
//                 i++;
//                 let braceContent = "";
//                 let braceCount = 1;

//                 while (i < str.length && braceCount > 0) {
//                     if (str[i] === '{' && str[i - 1] !== '\\') {
//                         braceCount++;
//                     } else if (str[i] === '}' && str[i - 1] !== '\\') {
//                         braceCount--;
//                         if (braceCount === 0) break;
//                     }
//                     braceContent += str[i];
//                     i++;
//                 }

//                 // Recursively process content inside command braces
//                 const processedContent = capitalizeInsideBraces(braceContent, isTitleCase);
//                 result += processedContent + '}';
//                 i++;
//             }
//             continue;
//         }

//         // ==================== Handle Words ====================
//         if (/[a-zA-Z]/.test(str[i])) {
//             let word = "";

//             // Collect the word
//             while (i < str.length && /[a-zA-Z0-9]/.test(str[i])) {
//                 word += str[i];
//                 i++;
//             }

//             const lowerWord = word.toLowerCase();

//             // Determine if we should capitalize
//             if (isFirstWord || afterPeriod) {
//                 // Always capitalize first word or word after period
//                 result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//                 isFirstWord = false;
//                 afterPeriod = false;
//             } else if (isTitleCase && skipWords.includes(lowerWord)) {
//                 // Title case: skip small words (unless after period)
//                 result += lowerWord;
//             } else if (isTitleCase) {
//                 // Title case: capitalize other words
//                 result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//             } else {
//                 // Sentence case: lowercase everything except first word
//                 result += lowerWord;
//             }

//             continue;
//         }

//         // ==================== Handle Period ====================
//         if (str[i] === '.') {
//             result += str[i];
//             afterPeriod = true; // Next word should be capitalized
//             i++;
//             continue;
//         }

//         // ==================== Handle Opening Brace { ====================
//         if (str[i] === '{') {
//             result += str[i];
//             i++;
//             isFirstWord = true; // Next word after { should be capitalized
//             continue;
//         }

//         // ==================== Handle Other Characters ====================
//         result += str[i];
//         i++;
//     }

//     return result;
// }






export function capitalizeInsideBraces(str, isTitleCase = true) {
    const skipWords = [
        "using",
        // Articles
        "a", "an", "the",

        // Conjunctions
        "and", "but", "or", "nor", "for", "so", "yet", "although", "because", "since", "unless", "whereas", "while", "although", "though",

        // Prepositions (short + common)
        "about", "above", "across", "after", "against", "along", "among", "around", "at", "before", "behind", "below", "beneath", "beside", "between", "beyond", "by", "despite", "down", "during", "except", "for", "from", "in", "inside", "into", "like", "near", "of", "off", "on", "onto", "out", "outside", "over", "past", "since", "through", "throughout", "till", "to", "toward", "towards", "under", "underneath", "until", "up", "upon", "with", "within", "without", "via", "per", "as", "than",

        // Pronouns (common)
        "i", "you", "he", "she", "it", "we", "they", "me", "him", "her", "us", "them", "my", "your", "his", "her", "its", "our", "their", "mine", "yours", "hers", "ours", "theirs", "this", "that", "these", "those", "any", "each", "few", "many", "all", "some", "most", "none", "one", "other", "another", "such", "what", "which", "who", "whom", "whose", "myself", "yourself", "himself", "herself", "itself", "ourselves", "themselves", "eachother",

        // Adverbs / common small words
        "even", "more", "also", "not", "just", "only", "still", "yet", "too", "very", "so", "ever", "never", "once", "always", "often", "sometimes", "usually", "rarely", "perhaps", "maybe", "actually", "indeed", "thus", "there", "here", "where", "when", "why", "how", "however", "instead", "meanwhile", "therefore", "furthermore", "additionally", "likewise", "similarly", "otherwise", "hence", "accordingly", "anyway", "anyhow", "already", "soon", "rather", "quite", "rather", "nearly", "hardly", "merely", "mostly", "mainly", "primarily", "largely", "partly", "somewhat", "relatively", "approximately", "nevertheless", "nonetheless", "besides", "aside", "henceforth", "forthwith", "altogether", "over", "under", "about", "around", "through", "throughout", "beyond", "toward", "towards", "without", "within",

        // Common filler / linking words
        "as", "if", "than", "until", "while", "so", "too", "like", "per", "via", "etc", "i.e", "e.g", "vs", "www", "com", "org", "net", "gov", "edu", "mil", "inc", "ltd", "co",

        // Modifiers / small adjectives
        "big", "small", "new", "old", "young", "other", "same", "main", "own", "first", "last", "next", "previous", "former", "latter", "only", "several", "many", "few", "some", "all", "any", "enough", "less", "more", "most", "certain", "certainly", "particular", "partly", "whole", "wholeheartedly",

        // Common adverbs used in captions
        "quickly", "slowly", "carefully", "easily", "hardly", "barely", "strongly", "lightly", "simply", "clearly", "visibly", "directly", "immediately", "gradually", "mainly", "primarily", "mainly", "slightly", "relatively", "partially", "usually", "commonly", "occasionally", "frequently", "rarely", "occasionally", "effectively", "accurately", "specifically", "generally", "typically", "mostly", "usually", "particularly", "especially", "sometimes", "eventually", "finally", "ultimately",

        // Time / quantity words
        "before", "after", "since", "until", "during", "recently", "formerly", "once", "twice", "thrice", "daily", "weekly", "monthly", "yearly", "hourly", "later", "earlier", "soon", "now", "then", "again", "already", "yet", "immediately", "eventually", "finally", "ultimately", "early", "late", "today", "yesterday", "tomorrow", "morning", "evening", "night", "afternoon", "midday", "midnight", "noon", "past", "next", "previous", "current", "following", "upcoming",

        // Misc / others
        "example", "examples", "fig", "figure", "table", "eq", "equation", "ref", "refs", "reference", "references", "section", "sections", "chapter", "chapters", "appendix", "appendices", "note", "notes", "supplementary", "supplement", "supplemental", "data", "dataset", "datasets", "sample", "samples", "value", "values", "parameter", "parameters", "variable", "variables", "result", "results", "observation", "observations", "method", "methods", "procedure", "procedures", "analysis", "analyses", "study", "studies", "experiment", "experiments", "test", "tests", "control", "controls", "treatment", "treatments", "group", "groups", "case", "cases", "item", "items", "part", "parts", "component", "components", "factor", "factors", "level", "levels", "type", "types", "category", "categories", "set", "sets", "range", "ranges", "line", "lines", "point", "points", "mean", "median", "mode", "variance", "standard", "deviation", "ratio", "ratios", "percentage", "percentages", "score", "scores", "scorecard", "sampled", "sampleset", "trial", "trials", "phase", "phases",

        // Common file extensions
        "jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "svg", "webp", "ico", "pdf", "txt", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "csv", "json", "xml", "html", "htm", "css", "js", "ts", "py", "cpp", "c", "h", "java", "rb", "php", "sh", "bat", "exe", "dll", "zip", "tar", "gz", "rar", "7z",

        // URLs / domain names
        "com", "org", "net", "gov", "edu", "mil", "io", "co", "info", "biz", "us", "uk", "de", "fr", "jp", "cn", "ru", "in", "au", "br", "ca", "es", "it", "nl", "se", "no", "fi", "dk", "ch", "be", "nz",

        // Common tech / acronyms often in captions
        "cpu", "gpu", "ram", "ssd", "hdd", "os", "ui", "ux", "api", "html", "css", "json", "xml", "sql", "db", "dns", "ip", "url", "tcp", "udp", "http", "https", "ftp", "smtp", "ssh", "tls", "ssl", "vpn", "vm", "cli", "gui", "ide", "sdk", "api", "iot", "ai", "ml", "dl", "nn", "cnn", "rnn", "lstm", "gan", "url", "uri", "jpg", "png", "gif", "bmp"
    ];
    let result = "";
    let i = 0;
    let isFirstWord = true;
    let afterPeriod = false;

    // Commands whose contents should NEVER be capitalized/modified
    const protectedCommands = ["mth", "chem", "ref", "cite", "label"];

    while (i < str.length) {
        // ==================== 1. Handle Math $...$ ====================
        if (str[i] === '$' && (i === 0 || str[i - 1] !== '\\')) {
            let mathBlock = "$";
            i++;
            while (i < str.length) {
                mathBlock += str[i];
                if (str[i] === '$' && str[i - 1] !== '\\') { i++; break; }
                i++;
            }
            result += mathBlock;
            continue;
        }

        // ==================== 2. Handle LaTeX Commands \\command{} ====================
        if (str[i] === '\\' && i + 1 < str.length && /[a-zA-Z]/.test(str[i + 1])) {
            result += '\\';
            i++;
            let cmdName = "";
            while (i < str.length && /[a-zA-Z]/.test(str[i])) {
                cmdName += str[i];
                result += str[i];
                i++;
            }

            // Skip whitespace
            while (i < str.length && /\s/.test(str[i])) { result += str[i]; i++; }

            if (i < str.length && str[i] === '{') {
                result += '{';
                i++;
                let braceContent = "";
                let braceCount = 1;
                while (i < str.length && braceCount > 0) {
                    if (str[i] === '{' && str[i - 1] !== '\\') braceCount++;
                    else if (str[i] === '}' && str[i - 1] !== '\\') {
                        braceCount--;
                        if (braceCount === 0) break;
                    }
                    braceContent += str[i];
                    i++;
                }

                // CHECK: Is this a protected command?
                if (protectedCommands.includes(cmdName.toLowerCase())) {
                    result += braceContent + '}'; // Keep exactly as is
                } else {
                    result += capitalizeInsideBraces(braceContent, isTitleCase) + '}';
                }
                i++;
            }
            continue;
        }

        // ==================== 3. Handle Words & Chem (H$_2$O) ====================
        // We modify the word detection to include $, _, and { } if they are part of a chemical string
        if (/[a-zA-Z]/.test(str[i])) {
            let word = "";
            let hasSpecialChemChar = false;

            // Collect word, but allow $, _, {, } inside it to capture H$_2$O or H_{2}O
            while (i < str.length && /[a-zA-Z0-9$_\{\}]/.test(str[i])) {
                if (/[$_\{\}]/.test(str[i])) hasSpecialChemChar = true;
                word += str[i];
                i++;
                // If we hit a space or punctuation not related to chem, stop
                if (i < str.length && /[\s,.?!:;]/.test(str[i])) break;
            }

            const lowerWord = word.toLowerCase();

            // If it contains $ or _, it's likely chemistry or math-text (H$_2$O)
            // We should leave these exactly as the user wrote them.
            if (hasSpecialChemChar) {
                result += word;
            } else if (isFirstWord || afterPeriod) {
                result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                isFirstWord = false;
                afterPeriod = false;
            } else if (isTitleCase && skipWords.includes(lowerWord)) {
                result += lowerWord;
            } else if (isTitleCase) {
                result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            } else {
                result += lowerWord;
            }
            continue;
        }

        // Handle Punctuation/Braces (Same as your current logic)
        if (str[i] === '.') { result += '.'; afterPeriod = true; i++; continue; }
        if (str[i] === '{') { result += '{'; i++; isFirstWord = true; continue; }

        result += str[i];
        i++;
    }
    return result;
}
export function isCommented(texFile, matchIndex) {
    const lineStart = texFile.lastIndexOf("\n", matchIndex - 1) + 1;
    const lineContent = texFile.slice(lineStart, matchIndex);

    // Find every % on this line before the match
    // but skip \% (escaped percent = literal percent sign, not a comment)
    for (let i = 0; i < lineContent.length; i++) {
        if (lineContent[i] === "%") {
            // Check if it's escaped — count backslashes before it
            let backslashCount = 0;
            let j = i - 1;
            while (j >= 0 && lineContent[j] === "\\") {
                backslashCount++;
                j--;
            }
            // Odd number of backslashes = escaped \% → not a comment
            // Even number (including 0) = real % → is a comment
            if (backslashCount % 2 === 0) {
                return true;  // real comment found before the match
            }
        }
    }
    return false;
}
export function getallData(file, startIndex) {
    const result = {
        text: "",
        squaretext: false,
        unnumbered: false,
        unnumberedbracket: false,
        fullMatch: "",
        patterns: {
            hasSquareBracket: false,
            hasAsterisk: false
        }
    };

    let i = startIndex;

    // Check for asterisk (*)
    if (file[i] === '*') {
        result.unnumbered = true;
        result.patterns.hasAsterisk = true;
        i++;
    }

    // Skip whitespace
    while (i < file.length && /\s/.test(file[i])) {
        i++;
    }

    // Check for square bracket []
    if (file[i] === '[') {
        result.patterns.hasSquareBracket = true;
        i++; // Skip opening [
        let squareContent = "";
        let bracketDepth = 1;

        while (i < file.length && bracketDepth > 0) {
            if (file[i] === '[') bracketDepth++;
            else if (file[i] === ']') {
                bracketDepth--;
                if (bracketDepth === 0) break;
            }
            squareContent += file[i];
            i++;
        }

        if (file[i] === ']') i++; // Skip closing ]

        if (result.unnumbered) {
            result.unnumberedbracket = squareContent;
        } else {
            result.squaretext = squareContent;
        }
    }

    // Skip whitespace
    while (i < file.length && /\s/.test(file[i])) {
        i++;
    }

    // Get content inside curly braces {}
    if (file[i] === '{') {
        const braceContent = getInsideTextofBraces(file.slice(i));
        result.text = braceContent.slice(1, -1); // Remove outer { }
        result.fullMatch = file.slice(startIndex, i + braceContent.length);
    }

    return result;
}

export function getInsideTextofBraces(file) {
    let data = "";
    let brace = 0;

    for (let i = 0; i < file.length; i++) {
        if (file[i] === "{") {
            brace++;
        }
        if (file[i] === "}") {
            brace--;
        }
        data = data + file[i];
        if (brace === 0) {
            break;
        }
    }

    return data;
}
export function createGranularAnchors(session, Range, texFile, fullMatchStart, fullMatchText, originalSpec, newSpec, markerClass, styleName, anchorlist) {
    const changes = [];
    const colSpecPattern = /\\begin\{[^}]+\}\s*(?:\[[^\]]*\])?\s*\{([^}]+)\}/;
    const colSpecMatch = fullMatchText.match(colSpecPattern);

    if (!colSpecMatch) return;

    const colSpecStartInMatch = colSpecMatch.index + colSpecMatch[0].lastIndexOf('{') + 1;
    const colSpecStartInFile = fullMatchStart + colSpecStartInMatch;

    let originalIdx = 0;
    let newIdx = 0;

    while (originalIdx < originalSpec.length || newIdx < newSpec.length) {
        if (originalIdx < originalSpec.length && newIdx < newSpec.length) {
            if (originalSpec[originalIdx] === newSpec[newIdx]) {
                originalIdx++;
                newIdx++;
            } else {
                let originalSegment = originalSpec[originalIdx];
                let newSegment = newSpec[newIdx];

                changes.push({
                    position: colSpecStartInFile + originalIdx,
                    length: originalSegment.length,
                    original: originalSegment,
                    replacement: newSegment,
                    columnIndex: originalIdx
                });

                originalIdx++;
                newIdx++;
            }
        } else if (originalIdx < originalSpec.length) {
            changes.push({
                position: colSpecStartInFile + originalIdx,
                length: 1,
                original: originalSpec[originalIdx],
                replacement: '',
                columnIndex: originalIdx
            });
            originalIdx++;
        } else {
            changes.push({
                position: colSpecStartInFile + originalIdx,
                length: 0,
                original: '',
                replacement: newSpec[newIdx],
                columnIndex: originalIdx
            });
            newIdx++;
        }
    }

    changes.forEach((change) => {
        const position = getPositionFromIndex(texFile, change.position, change.length);

        let description = '';
        if (change.original && change.replacement) {
            description = `Change column alignment: "${change.original}" → "${change.replacement}"`;
        } else if (change.replacement) {
            description = `Insert column alignment: "${change.replacement}"`;
        } else {
            description = `Remove column alignment: "${change.original}"`;
        }
        if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
            createAnchor(
                session,
                Range,
                position,
                change.original,
                change.replacement,
                markerClass,
                styleName,
                description,
                anchorlist
            );
        }
    });

    return changes;
}

// Helper to check if a line is commented
export const isLineCommented = (text, index) => {
    let lineStart = index;
    while (lineStart > 0 && text[lineStart - 1] !== '\n') {
        lineStart--;
    }
    const linePrefix = text.slice(lineStart, index);
    for (let i = 0; i < linePrefix.length; i++) {
        if (linePrefix[i] === '%' && (i === 0 || linePrefix[i - 1] !== '\\')) {
            return true;
        }
    }
    return false;
};